import { render, staticRenderFns } from "./BAVideoPlayer.vue?vue&type=template&id=187cfbfc&scoped=true&"
import script from "./BAVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./BAVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./BAVideoPlayer.vue?vue&type=style&index=0&id=187cfbfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187cfbfc",
  null
  
)

export default component.exports